// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Noto+Sans+JP:400,700&display=swap&subset=japanese);"]);
// Module
exports.push([module.id, ".mc-icon[data-v-0c9bbe2d]{pointer-events:none}.mc-mentor-info[data-v-0c9bbe2d]{margin-top:calc(40% + 64px)}.fade-enter-active[data-v-0c9bbe2d],.fade-leave-active[data-v-0c9bbe2d]{transition:opacity .3s}.fade-enter[data-v-0c9bbe2d],.fade-leave-to[data-v-0c9bbe2d]{opacity:0}", ""]);
// Exports
module.exports = exports;
